module.exports = __webpack_public_path__ + "static/media/great-learning-ui-study.3ca0c1e4.jpg";